'use client'

import Image from 'next/image'
import { Reveal, Counter, ParallaxReveal } from '@/components/motion-primitives'

// Real fintech & payment companies that might use Rombex
const LOGOS = [
  { name: 'Stripe', logo: '/logos/stripe.png' },
  { name: 'Wise', logo: '/logos/wise.png' },
  { name: 'Ripple', logo: '/logos/ripple.png' },
  { name: 'Coinbase', logo: '/logos/coinbase.png' },
  { name: 'Kraken', logo: '/logos/kraken.png' },
  { name: 'BlockFi', logo: '/logos/blockfi.jpg' },
  { name: 'dYdX', logo: '/logos/dydx.png' },
]

const STATS: { value: number; suffix?: string; label: string }[] = [
  { value: 190, suffix: '+', label: 'Countries' },
  { value: 40, suffix: '+', label: 'Currencies' },
  { value: 250, suffix: 'M+', label: 'Transactions' },
  { value: 2, suffix: 'k+', label: 'Users' },
  { value: 60, suffix: '+', label: 'Businesses' },
]

export function Stats() {
  return (
    <section className="border-y border-border bg-background py-14">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal className="text-center">
          <p className="text-sm font-medium text-muted-foreground">
            Trusted by teams building the next generation of global money movement
          </p>
        </Reveal>

        {/* Marquee logos */}
        <div className="relative mt-8 overflow-hidden [mask-image:linear-gradient(to_right,transparent,black_12%,black_88%,transparent)]">
          <div className="flex w-max animate-[marquee_32s_linear_infinite] items-center gap-16">
            {[...LOGOS, ...LOGOS].map((logo, i) => {
              // Reduce size for logos that appear too large
              const oversizedLogos = ['Coinbase', 'Kraken', 'BlockFi']
              const isOversized = oversizedLogos.includes(logo.name)
              const containerClass = isOversized ? 'h-8 w-8' : 'h-12 w-12'
              const sizeHint = isOversized ? '32px' : '48px'
              
              return (
                <div key={i} className="flex items-center gap-4 whitespace-nowrap">
                  <div className={`relative ${containerClass} flex-shrink-0`}>
                    <Image
                      src={logo.logo}
                      alt={logo.name}
                      fill
                      className="object-contain leading-none"
                      sizes={sizeHint}
                    />
                  </div>
                  <span className="text-sm font-medium text-foreground/50">
                    {logo.name}
                  </span>
                </div>
              )
            })}
          </div>
        </div>

        <ParallaxReveal className="mt-12 grid grid-cols-2 gap-6 sm:grid-cols-3 lg:grid-cols-5" offset={-50}>
          {STATS.map((s, i) => (
            <Reveal key={s.label} delay={i * 0.06} className="text-center">
              <div className="text-3xl font-semibold tracking-tight text-foreground sm:text-4xl">
                <Counter to={s.value} suffix={s.suffix} />
              </div>
              <div className="mt-1 text-sm text-muted-foreground">{s.label}</div>
            </Reveal>
          ))}
        </ParallaxReveal>
      </div>

      <style jsx>{`
        @keyframes marquee {
          from {
            transform: translateX(0);
          }
          to {
            transform: translateX(-50%);
          }
        }
      `}</style>
    </section>
  )
}
